<template lang="pug">
VListItem(@click="clickListItem")
  template(#prepend)
    VCheckboxBtn.mr-2(:model-value="itemIsInList")
  VListItemTitle {{ isDefaultList(listName) ? i18n.t("ReadingList.StarredListTitle") : listTitle }}
  template(
    v-if="isDefaultList(listName)"
    #append
  )
    VIcon(:color="itemIsInList ? 'secondary' : undefined") {{ itemIsInList ? mdiStar : mdiStarOutline }}
</template>

<script setup lang="ts">
import { computed } from "vue";
import { mdiStar, mdiStarOutline } from "@mdi/js";
import { useI18n } from "vue-i18n";
// noinspection ES6UnusedImports
import {
  isDefaultList,
  useReadingListsStore,
} from "~/stores/useReadingListsStore";

const i18n = useI18n();
const readingListsStore = useReadingListsStore();

interface Props {
  listName: string;
  listTitle: string;
  commentId: number;
}

const props = withDefaults(defineProps<Props>(), {});

function clickListItem(): void {
  if (itemIsInList.value) {
    readingListsStore.removeFromList(props.listName, [props.commentId]);
  } else {
    readingListsStore.addToList(props.listName, [
      { commentId: props.commentId, addedDate: Date.now() },
    ]);
  }
}

const itemIsInList = computed<boolean>(() => {
  return readingListsStore.listContainsItem(props.listName, props.commentId);
});
</script>
